var map = {
	"./bt-logo.svg": "3d36",
	"./fingers.svg": "90bb",
	"./gradient-background.png": "aa69",
	"./graph.svg": "ca78",
	"./heads.svg": "8f60",
	"./meter.svg": "29a6",
	"./office.jpg": "0b02",
	"./page-1-bg-statistics-report.jpg": "d116",
	"./quotes.png": "a723"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a0df";